<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: '--- Maker',
    titleTemplate: '%s - Codementum'
  },
  updated() {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1);
  }
};
</script>
